/* eslint-disable react/prop-types */

import "./Style/styles.css";

function Image({ imageUrl }) {
  const imgURL = imageUrl.map((item) => item.image_property);
  return (
    <>
      <img src={`${imgURL[0]}`} alt="Img" className="flag" />
    </>
  );
}

export default Image;
